import { Announcement } from '../types';

const filterAnnouncements = (value: string, announcements: Announcement[]): Announcement[] => {
  if (!value) return announcements;

  const lowerInput = value.toLowerCase();
  return announcements.filter(
    (announcement) =>
      announcement.Title?.toLowerCase().includes(lowerInput) ||
      announcement.Description?.toLowerCase().includes(lowerInput),
  );
};

export default filterAnnouncements;
